.Fireworks {
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 1000;
}

.burst {
    position: absolute;
    left: var(--burst-x);
    top: var(--burst-y);
    width: 0;
    height: 0;
    animation: burst-appear var(--burst-duration) ease-out var(--burst-delay) forwards;
    opacity: 0;
}

.particle {
    position: absolute;
    width: var(--particle-size);
    height: var(--particle-size);
    background-color: var(--burst-color);
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: particle-explode var(--burst-duration) ease-out var(--burst-delay) forwards;
    box-shadow: 0 0 6px var(--burst-color), 0 0 12px var(--burst-color);
}

.glow {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 20px;
    height: 20px;
    margin-left: -10px;
    margin-top: -10px;
    background: radial-gradient(circle, var(--burst-color) 0%, transparent 70%);
    border-radius: 50%;
    animation: glow-pulse var(--burst-duration) ease-out var(--burst-delay) forwards;
    opacity: 0;
}

@keyframes burst-appear {
    0% {
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    100% {
        opacity: 1;
    }
}

@keyframes particle-explode {
    0% {
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateY(0);
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    30% {
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateY(calc(var(--particle-distance) * -1));
        opacity: 1;
    }
    100% {
        transform: translate(-50%, -50%) rotate(var(--particle-angle)) translateY(calc(var(--particle-distance) * -1.5));
        opacity: 0;
    }
}

@keyframes glow-pulse {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    10% {
        transform: scale(1);
        opacity: 0.8;
    }
    30% {
        transform: scale(3);
        opacity: 0.4;
    }
    100% {
        transform: scale(5);
        opacity: 0;
    }
}
